@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

.sourcesHeader {
  padding: 4px 12px;
  @include typography-v2-body-sm;
  color: var(--text-soft);
  border-bottom: 1px solid var(--border-soft);
}

.stickySourcesHeader {
  @include typography-v2-body-sm;
  position: sticky;
  top: -1px;
  background-color: var(--background-soft);
  border-bottom-right-radius: 0;
  border-bottom: 1px solid var(--border-soft);

  &.isLast {
    border-bottom-right-radius: 8px;
    border-bottom: 0;
  }
}

.sourcesList {
  max-height: 30vh;
  overflow: hidden auto;
  @include custom-scroll-minimal;
  border-bottom-left-radius: 8px;
  display: flex;
  flex-direction: column;

  @include respond-to('max-sm') {
    max-height: 20vh;
  }
}
